import React from 'react';
import './App.css';
import './styles/global.css';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { Routes, Route } from 'react-router-dom';

import ModernNavbar from './Components/ModernNavbar';
import Home from './Pages/Home';
import Uses from './Pages/Uses';
import Projects from './Pages/Projects';
import GetCookie from './Services/GetCookie';
import Data from './Data/.json';
import NotFound from './Pages/NotFound';
import About from './Pages/About';
import Services from './Pages/Services';
import Contact from './Pages/Contact';
import Career from './Pages/Career';
import { theme, darkTheme } from './styles/theme';
import { AnimatePresence } from 'framer-motion';

function App() {
  const cookieMode = GetCookie(Data.mode) || 'light';
  const currentTheme = cookieMode === 'dark' ? darkTheme : theme;
  
  return (
    <ThemeProvider theme={currentTheme}>
      <CssBaseline />
      <div className="App">
        <ModernNavbar />
        <AnimatePresence mode="wait">
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path='/uses' element={<Uses />} />
            <Route path='/projects' element={<Projects />} />
            <Route path='/services' element={<Services />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/career' element={<Career />} />
            <Route path='*' element={<NotFound />} />
          </Routes>
        </AnimatePresence>
      </div>
    </ThemeProvider>
  );
}

export default App;
